export default __webpack_public_path__ + "scripts/resources/assignments/en/colligative/solution_nonaq/species.json";